import Vue from 'vue';
import router from './router/panel-component';
import vuetify from './plugins/vuetify';
import store from './store';
import './scss/main.scss';
import App from './App.vue';
import drr from '@minogin/vue-drag-resize-rotate'

Vue.component('vue-drr', drr);
Vue.config.productionTip = false;

new Vue({
	router,
	vuetify,
	store,
	render: h => h(App),
}).$mount('#app');

document.addEventListener(
	'wheel',
	function (e) {
		// Check if the event target or any of its parents have the class 'your-popup-class'
		if (e.target.closest('.v-overlay--active') || e.target.closest('.v-overlay--scrim')) {
			e.preventDefault();
		}
	},
	{ passive: false }
);